var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSjcd = function SvgSjcd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.177 47.5.07.005a.5.5 0 0 1 .377.271l1.58 3.16c1.162 2.327-.53 5.064-3.132 5.064H6.927c-2.602 0-4.294-2.737-3.131-5.065l1.58-3.159.035-.06a.501.501 0 0 1 .412-.216h48.354Zm0-9 .07.005a.5.5 0 0 1 .377.271l1.58 3.16c1.162 2.327-.53 5.064-3.132 5.064H6.927c-2.602 0-4.294-2.737-3.131-5.065l1.58-3.159.035-.06a.501.501 0 0 1 .412-.216h48.354ZM19.757 22a3.5 3.5 0 0 1 2.474 1.025l6 6a2.5 2.5 0 0 0 3.537 0l6-6A3.5 3.5 0 0 1 40.242 22h7.404a5 5 0 0 1 4.472 2.764l4.085 8.17c1.164 2.328-.529 5.066-3.13 5.066H6.926c-2.602 0-4.295-2.738-3.131-5.065l4.086-8.171A5 5 0 0 1 12.354 22h7.403ZM30 14.5a2 2 0 0 1 2 2v5.67l1.085-1.084a2 2 0 0 1 2.83 2.828l-4.5 4.5a2 2 0 0 1-2.83 0l-4.5-4.5a2 2 0 0 1 2.83-2.828L28 22.172V16.5a2 2 0 0 1 2-2ZM15 4a2 2 0 0 1 2 2v5.67l1.085-1.084a2 2 0 0 1 2.83 2.828l-4.5 4.5a2 2 0 0 1-2.83 0l-4.5-4.5a2 2 0 0 1 2.83-2.828L13 11.672V6a2 2 0 0 1 2-2Zm30 0a2 2 0 0 1 2 2v5.67l1.085-1.084a2 2 0 0 1 2.83 2.828l-4.5 4.5a2 2 0 0 1-2.83 0l-4.5-4.5a2 2 0 0 1 2.83-2.828L43 11.672V6a2 2 0 0 1 2-2Z",
    fill: "url(#sjcd_svg__a)",
    stroke: "url(#sjcd_svg__b)",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sjcd_svg__a",
    x1: 30,
    y1: 4.5,
    x2: 30,
    y2: 55.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sjcd_svg__b",
    x1: 30,
    y1: 4.5,
    x2: 30,
    y2: 55.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};

export default SvgSjcd;